import React from "react";
import Popup from "src/components/popup/Popup";
import ReFreshForm from "src/pages/AccessControl/pages/Re_fresh/Re_freshForm";

const RefreshChangeKeyPopup = ({ openPopup, setOpenPopup }) => {
  return (
    <Popup
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "900px", // Set your width here
          },
        },
      }}
      title={"Change Key"}
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
    >
      <ReFreshForm setOpenPopupChangeKey={setOpenPopup} />
    </Popup>
  );
};

export default RefreshChangeKeyPopup;
